const ui = {};

ui.setInput = function(element, value) {
    $(element).val(value);
}

ui.accordion = function(element) {
    $(element).accordion();
}

ui.dropdown = function(element, onChange) {
    $(element).dropdown({
        onChange: function(value, text, $selectedItem) {
            onChange(value);
        }
    });
};

ui.checkbox = function(element, onChange) {
    $(element).checkbox({
        onChange: function(value, text, $selectedItem) {
            onChange(value);
        }
    });
};

ui.setDropdownValues = function(element, values) {
    $(element).dropdown('change values', values);   // values: [{ name, value }]
}

ui.setDropdownSelected = function(element, value) {
    $(element).dropdown("set selected", value);
}

ui.clearDropdown = function(element) {
    $(element).dropdown("clear");
};


const korDays = ["일", "월", "화", "수", "목", "금", "토" ];
const korMonths = ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월" ];

const formatterDate = function(date, settings) {
    if (!date) return "";
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return year + "/" + month + "/" + day;
};

const korFormatterDate = function(date, settings) {
    if (!date) return "";
    const year = date.getFullYear();
    const month = korMonths[date.getMonth()];
    const day = date.getDate();
    return year + "년 " + month + " " + day + "일";
};

ui.calendar = function(element, onChange) {
    $(element).calendar({
        type: "date",
        text: {
            days: korDays,
            months: korMonths,
            monthsShort: korMonths,
        },
        formatter: {
            date: formatterDate,
        },
        onChange: function(date, text) {
            if (onChange) { onChange(date, text); }
        }
    });
};

ui.calendarYesterday = function(element, onChange) {
    const today = new Date();
    $(element).calendar({
        type: "date",
        text: {
            days: korDays,
            months: korMonths,
            monthsShort: korMonths,
        },
        maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
        formatter: { date: formatterDate, },
        onChange: function(date, text) {
            if (onChange) { onChange(date, text); }
        }
    });
};

ui.calendar_StartEnd = function(startCalendarName, endCalendarName, onStartChange, onEndChange) {
    const today = new Date();
    $(startCalendarName).calendar({
        type: "date",
        maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        text: {
            days: korDays,
            months: korMonths,
            monthsShort: korMonths,
        },
        formatter: {
            date: formatterDate,
        },
        endCalendar: $(endCalendarName),
        onChange: function(date, text) {
            if (onStartChange) { onStartChange(date, text); }
        }
    });
    $(endCalendarName).calendar({
        type: "date",
        maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        text: {
            days: korDays,
            months: korMonths,
            monthsShort: korMonths,
        },
        formatter: {
            date: formatterDate,
        },
        startCalendar: $(startCalendarName),
        onChange: function(date, text) {
            if (onEndChange) { onEndChange(date, text); }
        }
    });
};

ui.korCalendar = function(calendarName, onChange) {
    $(calendarName).calendar({
        type: "date",
        text: {
            days: korDays,
            months: korMonths,
            monthsShort: korMonths,
        },
        formatter: {
            date: korFormatterDate,
        },
        onChange: function(date, text) {
            if (onChange) { onChange(date, text); }
        }
    });
};

ui.korCalendar_StartEnd = function(startCalendarName, endCalendarName, onChange) {
    $(startCalendarName).calendar({
        type: "date",
        text: {
            days: korDays,
            months: korMonths,
            monthsShort: korMonths,
        },
        formatter: {
            date: korFormatterDate,
        },
        endCalendar: $(endCalendarName),
        onChange: function(date, text) {
            if (onChange) { onChange(date, text); }
        }
    });
    $(endCalendarName).calendar({
        type: "date",
        text: {
            days: korDays,
            months: korMonths,
            monthsShort: korMonths,
        },
        formatter: {
            date: korFormatterDate,
        },
        startCalendar: $(startCalendarName),
        onChange: function(date, text) {
            if (onChange) { onChange(date, text); }
        }
    });
};

ui.install = function(Vue) {
    Vue.prototype.$ui = ui;
}

export default ui;


// WEBPACK FOOTER //
// ./src/ui.js